import siteCarouselTheme from './siteCarouselTheme';

const siteCarouselDarkTheme = {
    carousel: {
        ...siteCarouselTheme.carousel,
    },
};

export default siteCarouselDarkTheme;
